import React from 'react';
import { connect } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import 'whatwg-fetch';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import Button from 'jbc-front/components/Button';
import CommonModal from 'jbc-front/components/CommonModal';
import { RadioField, CheckboxField } from 'jbc-front/components/Form';
import { ENCODING_OPTIONS } from 'src/constants/Options';
import { EMPLOYEE_FORM } from 'src/constants/FormNames';
import DownloadCsvEncodingRadioButton from 'src/components/DownloadCsvEncodingRadioButton';

import styles from './DownloadCsvModal.scss';
import { CustomYearPicker } from './CustomYearPicker';

const DownloadCsvInsideForm = ({ selectedYear, submit, submitting, hideModal, isOpen, dispatch, useTaxCalculation }) => {
  const { t } = useTranslation();
  const allEmployees = t('features.Employees.components.DownloadCsvModal.all_employees');
  const searchEmployees = t('features.Employees.components.DownloadCsvModal.Employees_in_search_filter');
  const DOWNLOAD_TARGET = [{ value: 'all', label: allEmployees }, { value: 'search', label: searchEmployees }];
  const TAX_YEAR_TARGET = [
    { value: '1', label: t('features.Employees.components.DownloadCsvModal.select') },
    { value: '0', label: t('features.Employees.components.DownloadCsvModal.not_select') }
  ];
  const header = t('features.Employees.components.DownloadCsvModal.Employee_data_download');

  const onYearPickerChange = e => {
    const selectYear = moment(e).year();
    dispatch(change(EMPLOYEE_FORM, 'yearTaxSetting', selectYear));
  };

  return (
    <CommonModal isOpen={isOpen} hideModal={hideModal} ariaHideApp={false} closeOnClick>
      <CommonModal.Header hideModal={hideModal}>{header}</CommonModal.Header>
      <form>
        <CommonModal.Body style={{ overflow: 'visible' }}>
          <div className={styles.label}>{t('features.Employees.components.DownloadCsvModal.Select_file_format')}</div>
          <DownloadCsvEncodingRadioButton name={'encoding'} label={null} options={ENCODING_OPTIONS} required={false} />
          <div className={styles.label}>{t('features.Employees.components.DownloadCsvModal.Select_a_download_target')}</div>
          <RadioField label="" name="target" options={DOWNLOAD_TARGET} />
          <div className={styles.label}>{t('features.Employees.components.DownloadCsvModal.select_tax_deduction_year')}</div>
          <RadioField name="useTaxCalculation" options={TAX_YEAR_TARGET} />
          {useTaxCalculation === '1' && <CustomYearPicker name="yearTaxSetting" value={selectedYear} onChange={onYearPickerChange} />}
          <div className={styles.checkboxWrapper}>
            <CheckboxField name="attachSampleData" label={t('features.Employees.components.DownloadCsvModal.attach_sample_data_in_download')} />
          </div>
          <div className={styles.note}>
            <div>{t('features.Employees.components.DownloadCsvModal.All_Employees_Download_all_employee_information_Except_for_retired_employees')}</div>
            <div>
              {t(
                'features.Employees.components.DownloadCsvModal.Search_filtered_employee_Download_the_information_of_the_filtered_employee_in_the_employee_list'
              )}
            </div>
            <div>{t('features.Employees.components.DownloadCsvModal.tax_deduction_note')}</div>
            <div>{t('features.Employees.components.DownloadCsvModal.attach_sample_data_description')}</div>
          </div>
        </CommonModal.Body>
        <CommonModal.Footer>
          <Button onClick={hideModal} className="u-mr20">
            {t('components.BonusFormModal.Cancel')}
          </Button>
          <Button primary onClick={submit} disabled={submitting}>
            {t('features.Employees.components.DownloadCsvModal.Download')}
          </Button>
        </CommonModal.Footer>
      </form>
    </CommonModal>
  );
};

const mapStateToProps = state => ({
  selectedYear: getFormValues(EMPLOYEE_FORM)(state).yearTaxSetting,
  useTaxCalculation: getFormValues(EMPLOYEE_FORM)(state).useTaxCalculation
});

export default connect(mapStateToProps)(DownloadCsvInsideForm);
